import React from 'react';

/**
 * This function is used to find if an element is a react element
 * @param {String|null|ReactElement} element
 * @returns if element is a react element
 */
function isReactElement(element) {
  return typeof element === 'function' && /*#__PURE__*/React.isValidElement(element({}));
}

// eslint-disable-next-line import/prefer-default-export
export { isReactElement };